// extracted by mini-css-extract-plugin
export default {"navbar":"classes_navbar__sruJn"};